import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useLocaleKeys } from '~/i18n';
export const useFetchInvoices = (requestParams, param)=>{
    let { useExternalEndpoint, refreshOnHookMount = false } = param;
    const { api } = useStoreActions();
    const { t: errorTexts } = useLocaleKeys('errors');
    const queryKey = [
        QueryKeys.Invoices,
        requestParams
    ];
    const { data, isLoading, isBackgroundLoading, refresh, error } = useQueryState({
        queryKey,
        queryFn: ()=>{
            if (requestParams == null) throw new Error('useFetchInvoices: requestParams must be provided when enabled');
            return useExternalEndpoint ? api.invoice.getInvoices(requestParams) : api.invoice.getAll(requestParams);
        },
        keepPreviousData: true,
        staleTime: 0,
        enabled: requestParams != null,
        refreshOnHookMount,
        toasts: {
            errorMessage: errorTexts.unexpected(),
            errorTestId: 'fetch-invoices-error'
        }
    });
    return {
        data,
        isLoading,
        isBackgroundLoading,
        refresh,
        error
    };
};
